/**
 * Created by yb on 2018/6/11.
 * 时间格式化
 */
//时间转换函数
function transferTimeShort(obj) {
    var date = new Date(obj);
    var create_year = date.getFullYear();
    var create_month = date.getMonth() + 1;
    var create_day = date.getDate();
    var create_hour = date.getHours();
    var create_minute = date.getMinutes();
    var create_second = date.getSeconds();
    var date_str = toDouble(create_year) + "-" + toDouble(create_month) + "-" + toDouble(create_day);
    return date_str;
}

function transferTime(obj) {
    var date = new Date(obj);
    var create_year = date.getFullYear();
    var create_month = date.getMonth() + 1;
    var create_day = date.getDate();
    var create_hour = date.getHours();
    var create_minute = date.getMinutes();
    var create_second = date.getSeconds();
    // var date_str = toDouble(create_year) + "-" + toDouble(create_month) + "-" + toDouble(create_day) + " " + toDouble(create_hour) + ":" + toDouble(create_minute) + ":" + toDouble(create_second);
    var date_str = toDouble(create_year) + "-" + toDouble(create_month) + "-" + toDouble(create_day) ;
    return date_str;
}

function toDouble(str) {
    var obj = str.toString();
    if(obj.length == 1) {
        return "" + 0 + obj;
    } else {
        return obj;
    }
}

Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1, //month
        "d+": this.getDate(), //day
        "h+": this.getHours(), //hour
        "m+": this.getMinutes(), //minute
        "s+": this.getSeconds(), //second
        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
        "S": this.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,(this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp("(" + k + ")").test(format))format = format.replace(RegExp.$1,RegExp.$1.length == 1 ? o[k] :("00" + o[k]).substr(("" + o[k]).length));
    return format;
}

export  {transferTimeShort}
export  {transferTime}


// WEBPACK FOOTER //
// ./src/tools/time/time.js